export type RatingAndCommentCardState =
  | "default"
  | "not-cooked"
  | "ongoing"
  | "saved-compressed"
  | "saved-no-comment"
  | "saved-expanded";

interface RatingCardStateProps {
  initialRating?: number;
  comment?: string;
  currentRating?: number;
}

const isInCardStateSet = (
  stateSet: Set<RatingAndCommentCardState>,
  state: RatingAndCommentCardState,
) => stateSet.has(state);

const createStateSet = (
  states: RatingAndCommentCardState[],
): Set<RatingAndCommentCardState> => new Set(states);

const SAVED_STATES = createStateSet([
  "saved-compressed",
  "saved-no-comment",
  "saved-expanded",
]);

const STATES_WITH_COMMENT = createStateSet([
  "saved-compressed",
  "saved-expanded",
]);

const STATES_WITHOUT_COMMENT = createStateSet(["saved-no-comment"]);

const NOT_COOKED_STATES = createStateSet(["default", "not-cooked"]);

export const getStateStatus = (cardState: RatingAndCommentCardState) => ({
  isRatingSaved: isInCardStateSet(SAVED_STATES, cardState),
  isRatingSavedWithComment: isInCardStateSet(STATES_WITH_COMMENT, cardState),
  isRatingSavedWithoutComment: isInCardStateSet(
    STATES_WITHOUT_COMMENT,
    cardState,
  ),
  isDishNotMade: isInCardStateSet(NOT_COOKED_STATES, cardState),
  isRatingOngoing: cardState === "ongoing",
});

export const getRatingCardState = ({
  initialRating,
  comment,
  currentRating,
}: RatingCardStateProps): RatingAndCommentCardState => {
  const haveNotMadeDish = currentRating === 0;

  if (!initialRating) {
    return "default";
  }

  if (haveNotMadeDish) {
    return "not-cooked";
  }

  return comment ? "saved-compressed" : "saved-no-comment";
};
